import { useTheme } from '@mui/material';
import { ScreenSizes } from '@interfaces';

export const useStyles = () => {
  const { breakpoints } = useTheme();

  return {
    root: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
    },
    content: {
      display: 'grid',
      gridTemplateColumns: 'repeat(4, 1fr)',
      gridAutoRows: 'max-content',
      gap: '16px',
      justifyContent: 'center',
      height: '100%',
      [breakpoints.down(ScreenSizes.TabletHorizontal)]: {
        padding: '8px',
      },
    },
  };
};
